import React, {Component} from 'react';
import {Container, DropContainer, UploadMessage} from './styles';
import {IoMdClose} from 'react-icons/io';
import Dropzone from 'react-dropzone';
import CurrencyInput from 'react-currency-input';
import Papel from '../../../../../assets/emojis/papel/papel@3x.png';
import Modal from 'react-modal';
import { uniqueId } from 'lodash';
import filesize from 'filesize';
import Lixeira from '../../../../../assets/produtos/lixeira/icon/fechar-circle@3x.png';
import ImageIcon from '../../../../../assets/icon_image.svg';
import api from '../../../../../services/api';
import { MdCheckCircle, MdError } from 'react-icons/md';
import {CircularProgressbar} from 'react-circular-progressbar';


export default class ModalItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            superUser: false,
            carregou: true,
            imagem: null,
            id: uniqueId(),
            nome: '',
            descricao: '',
            preco: '0.00',
            nomeClass: 'div-input',
            precoClass: 'div-input',
            descClass: 'div-input',
            windowWidth: window.innerWidth,
            itens: [],
            uploaded: [],
            token: props.token,
            ativo: true
        }
    }

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    }

    componentDidMount() {
        Modal.setAppElement('body');
        window.addEventListener("resize", this.handleResize);
        if (JSON.stringify(this.props.prevInfos) !== '{}') {
            const prev = this.props.prevInfos;
            this.setState({
                imagem: prev.imagem,
                id: prev.id,
                nome: prev.nome,
                descricao: prev.descricao,
                preco: prev.valor,
                ativo: prev.ativo
            });
            if (prev.imagem === null) {
                return null
            } else {
                this.setState({
                    uploaded: [{
                        preview: `https://appedidos-share-private.s3.amazonaws.com/${prev.imagem}`,
                        uploaded: true
                    }],
                })
                console.log(`https://appedidos-share-private.s3.amazonaws.com/${prev.imagem}`)
            }
        }
    }

    async componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize, false)
    }

    handleInputs(event) {
        switch (event.target.name) {
            case 'preco':
                var preco = event.target.value;
                var formatValue1 = preco.split(' ');
                var formated1 = formatValue1[1]?.replace(/,/g, '.');
                this.setState({
                    preco: Number(formated1).toFixed(2)
                });
                break;
            case 'nome':
                this.setState({
                    nome: event.target.value
                });
                break;
            case 'desc':
                this.setState({
                    descricao: event.target.value
                });
                break;
            default:
                break;
        }
    }

    handleCounter(element, type) {
        const min = this.state.counterMin;
        const max = this.state.counterMax;
        if (element === 'min') {
            if (this.state.adicionais === 1) {
                if (type === 'add') {
                    if (min >= max) {
                        return null
                    } else {
                        this.setState({
                            counterMin: min + 1
                        })
                    }
                }
                if (type === 'del') {
                    if (min === 1) {
                        return null
                    } else {
                        this.setState({
                            counterMin: min - 1
                        })
                    }
                }
            }
        }
        if (element === 'max') {
            if (type === 'add') {
                this.setState({
                    counterMax: max + 1
                })
            }
            if (type === 'del') {
                if (max === 1 || min >= max) {
                    return null
                } else {
                    this.setState({
                        counterMax: max - 1
                    })
                }
            }
        }
    }

    toggleAdicionais(tipo) {
        this.setState({ adicionais: tipo });
        if (tipo === 1) {
            this.setState({
                counterMin: 1
            })
        } else {
            this.setState({
                counterMin: 0
            })
        }
    }

    handleDelFoto() {
        if (JSON.stringify(this.props.prevInfos) === '{}') {
                try { 
                api.post('api/delete_image_s3', {
                    file_name: this.state.imagem
                }, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                }).then(res => {
                    console.log(res.data);
                    this.setState({ uploaded: [], imagem: null });
                })
            } catch (e) {
                console.log(e.data);
            }
        } else {
            this.setState({ uploaded: [], imagem: null });
        }
    }

    //para salvar produtos adicionais
    async save() {
        if (!!this.state.nome.length) { //nome vazio = false
                if (!!this.state.uploaded[0]) { //false
                    await this.processUpload(this.state.uploaded[0]);
                    this.props.push(this.state.id, this.state.ativo, this.state.imagem, this.state.nome, this.state.preco, this.state.descricao)

                } else {
                    this.props.push(this.state.id, this.state.ativo, this.state.imagem, this.state.nome, this.state.preco, this.state.descricao)
                }
        } else {
            if (!this.state.nome.length) { //nome vazio = true e nome preenchido = false
                this.setState({nomeClass: 'div-input-error'})
            }
        }
        this.props.closeModal();
        //  window.location.href="http://localhost:3000/produtos"

    }

    renderDragMessage = (isDragActive, isDragReject, state, type) => {
        if (isDragActive) {
            if (isDragReject) {
                return <UploadMessage type="error">
                    <span className="bold">Arquivo não suportado</span>
                </UploadMessage>
            } else {
                return <UploadMessage >
                    <span className="bold">Solte a imagem aqui</span>
                </UploadMessage>
            }
        }

        if (!!state.length) {
            return <UploadMessage>
                <span className="nome">{state[0].name}</span>
                <span>Para alterar a imagem arraste e solte ou clique 
                <p>para importar do seu dispositivo.</p></span>
            </UploadMessage>
        }

        if (!state.length) {
            return (
                this.state.windowWidth > 423 ? (
                    <UploadMessage>
                        <span><span className="bold">Arraste e solte</span> {type ? 'o seu logo' : 'a foto do seu produto'} 
                        <p>ou <span className="bold">clique para importar</span> do seu dispositivo.</p></span>
                    </UploadMessage>
                ) : (
                    <UploadMessage>
                        <span><span className="bold">Tire a foto</span> {type ? 'o seu logo' : 'do seu produto'} 
                        <p>ou <span className="bold">clique para importar</span> <p>do seu dispositivo.</p></p></span>
                    </UploadMessage>
                )
            )
        }
    }

    handleUpload = file => {
        const uploaded = file.map(file => ({
            file,
            id: uniqueId(),
            name: file.name,
            readableSize: filesize(file.size),
            preview: URL.createObjectURL(file),
            progress: 0,
            uploaded: false,
            error: false,
            url: null,
        }));
        this.setState({
            uploaded
        })
        // if (JSON.stringify(this.props.prevInfos) === '{}') {
            this.processUpload(this.state.uploaded[0]);
        // }
    }

    updateImage = (id, data) => {
        this.setState({ uploaded: this.state.uploaded.map(uploadedFile => {
            return id === uploadedFile.id 
                ? { ...uploadedFile, ...data }
                : uploadedFile;
            })
        });
    };

    processUpload = (upload) => {
        console.log(upload)
        if (!upload.uploaded) {
            const data = new FormData();
            data.append('file', upload.file, upload.name);
            api.post(`api/image_upload_s3`, data, {
                onUploadProgress: e => {
                    const progress = parseInt(Math.round(e.loaded * 100 / e.total));
                    this.updateImage(upload.id, {
                        progress,
                    })
                },
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(async res => {
                console.log(res);
                this.setState({
                    imagem: res.data.key
                })
                this.updateImage(upload.id, {
                    uploaded: true,
                });
                // if (JSON.stringify(this.props.prevInfos) !== '{}') {
                //     this.props.push(this.state.id, this.state.imagem, this.state.nome, this.state.preco, this.state.descricao);
                // }
                // this.success();
            }).catch(e => {
                // if (e.response.status === 500) {
                //     alert('Seu arquivo ultrapassou o limite de tamanho. Por favor, escolha outro arquivo e faça o upload.');
                // }
                this.updateImage(upload.id, {
                    error: true,
                });
                // this.error();
            })
        }
    }

    render() {
        return (
            <Container>
                <div className="close">
                    <button 
                        onClick={() => this.props.closeModal()}>
                        <IoMdClose color="#fff" className="i-close" />
                    </button>
                </div>
                
                <div className="header">
                    <img alt="" className="emoji" src={Papel} />
                    <h1>Vamos configurar <p>o seu item adicional</p></h1>
                </div>

                <div className="imagem">
                    <h4>Foto do produto</h4>

                    <div className="foto">
                        {!!this.state.uploaded.length ? (
                                <div 
                                    className="preview"
                                    onClick={() => this.handleDelFoto()}>
                                        <img src={Lixeira} alt="" className="lixeira"/>
                                        <div className="imagem">
                                            <img src={this.state.uploaded[0].preview} alt="" className="prev" />
                                        </div>
                                        <div style={{position: 'absolute', width: 28, height: 28, right: 3, bottom: 3}}>
                                            {!this.state.uploaded[0].uploaded && !this.state.uploaded[0].error && (
                                                <CircularProgressbar
                                                styles={{
                                                    root: { width: 24 },
                                                    path: { stroke: '#333333' }
                                                }}
                                                strokeWidth={10}
                                                value={this.state.uploaded[0].progress}
                                                />
                                            )}
                                            { this.state.uploaded[0].uploaded && !this.state.uploaded[0].error &&  <MdCheckCircle size={28} color="#4e9721" /> }
                                            { this.state.uploaded[0].error && !this.state.uploaded[0].uploaded &&  <MdError size={28} color="#c32027" /> }
                                        </div>
                                </div>
                        ) : (
                            <Dropzone accept="image/jpeg, image/png, image/pjpeg" multiple={false} onDropAccepted={
                                (file) => this.state.superUser ? 
                                this.state.permission === 2 ? this.handleUpload(file) : null 
                                : this.handleUpload(file)
                            }>
                                {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                    <DropContainer
                                        {...getRootProps()}
                                        haveImage={!!this.state.uploaded.length}
                                        isDragActive={isDragActive}
                                        isDragReject={isDragReject}
                                    >
                                        <input {...getInputProps()}/>
                                        <img src={ImageIcon} alt="" className="icon-image"/>
                                        {this.renderDragMessage(isDragActive, isDragReject, this.state.uploaded, 0)}
                                        {/* {!!this.state.uploaded.length && (
                                            <div style={{width: 28, height: 28, marginTop: 3}}>
                                            {!this.state.uploaded[0].uploaded && !this.state.uploaded[0].error && !isDragActive && (
                                                <CircularProgressbar
                                                styles={{
                                                    root: { width: 24 },
                                                    path: { stroke: '#333333' }
                                                }}
                                                strokeWidth={10}
                                                value={this.state.uploaded[0].progress}
                                                />
                                            )}
                                            { this.state.uploaded[0].uploaded && !this.state.uploaded[0].error && !isDragActive && <MdCheckCircle size={28} color="#4e9721" /> }
                                            { this.state.uploaded[0].error && !this.state.uploaded[0].uploaded && !isDragActive && <MdError size={28} color="#c32027" /> }
                                        </div>)} */}
                                    </DropContainer>
                                )}
                            </Dropzone>
                        )}
                    </div>
                </div>
            
                <hr />

                <div className="info">
                    <h4>Informações básicas</h4>
                    <div className={this.state.nomeClass}>
                            <input
                                value={this.state.nome}
                                onFocus={() => {
                                    this.setState({
                                        nomeClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        nomeClass: 'div-input'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                        this.state.permission === 2 ? this.handleInputs(e) : null 
                        : this.handleInputs(e)
                                }
                                name="nome"
                                type="text"
                                // placeholder="Digite o seu usuário"
                                required 
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Nome do item</span>
                            </label>
                    </div>
                    {this.state.nomeClass === 'div-input-error' && 
                    <div className="div-invalido">
                        <span
                        className='texto-invalido'
                        >Campo obrigatório</span>
                    </div>}
            
                    <div className={this.state.descClass}>
                            <input
                                value={this.state.descricao}
                                onFocus={() => {
                                    this.setState({
                                        descClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        descClass: 'div-input'
                                    })
                                }}
                                onChange={
                                    (e) => this.state.superUser ? 
                        this.state.permission === 2 ? this.handleInputs(e) : null 
                        : this.handleInputs(e)
                                }
                                name="desc"
                                type="text"
                                // placeholder="Digite o seu usuário"
                                required 
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Descrição</span>
                            </label>
                    </div>

                    <div className={this.state.precoClass}>
                            <CurrencyInput
                                inputType="text"
                                maxLength="9"
                                name="preco"
                                prefix="R$ "
                                onFocus={() => {
                                    this.setState({
                                        precoClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        precoClass: 'div-input'
                                    })
                                }}
                                required
                                decimalSeparator=","
                                value={this.state.preco}
                                onChangeEvent={
                                    (e) => this.state.superUser ? 
                        this.state.permission === 2 ? this.handleInputs(e) : null 
                        : this.handleInputs(e)
                                }
                            />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Preço</span>
                            </label>
                    </div>
                    
                </div>

                <div className="botao-div" style={{paddingBottom: 64, paddingTop: 24}}>
                    <button
                        className="salvar" 
                        onClick={() => {this.props.closeModal(); this.save()}}>
                            Salvar alterações</button>
                </div>
            </Container>
        )
    }
}